export const TYPE_SMS_QUOTE = "send-sms-quote"
export const TYPE_SMS_ORDER = "send-sms-order"
export const TYPE_SMS_INVOICE = "send-sms-invoice"

export namespace DOC_TEMPLATE {
    export const QUOTE_TEMPLATE = "quote-template"
    export const INVOICE_TEMPLATE = "invoice-template"
    export const ORDER_TEMPLATE = "order-template"
    export const CONTRACT_TEMPLATE = "contract-template"
}
export type DOC_TEMPLATE = typeof DOC_TEMPLATE[keyof typeof DOC_TEMPLATE]

export namespace EMAIL_TEMPLATE {
    export const TYPE_EMAIL_QUOTE = "send-proposal"
    export const TYPE_EMAIL_ORDER = "send-order"
    export const TYPE_EMAIL_INVOICE = "send-invoice"
    export const TYPE_EMAIL_CONTRACT = "send-contract"
    export const TYPE_EMAIL_PRICE_LIST = "new-order-from-price-list"
}
export type EMAIL_TEMPLATE = typeof EMAIL_TEMPLATE[keyof typeof EMAIL_TEMPLATE]

export const isOfTypeEmailTemplate = (keyInput: string): boolean => {
    return [
        EMAIL_TEMPLATE.TYPE_EMAIL_CONTRACT,
        EMAIL_TEMPLATE.TYPE_EMAIL_QUOTE,
        EMAIL_TEMPLATE.TYPE_EMAIL_INVOICE,
        EMAIL_TEMPLATE.TYPE_EMAIL_ORDER,
        EMAIL_TEMPLATE.TYPE_EMAIL_PRICE_LIST
    ].includes(keyInput)
}

export const TYPE_MAIL = "mail"


// WEBPACK FOOTER //
// ./src/state/template/TemplateType.ts